import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/seo';
import PostItem from '../components/PostItem';
import TitlePage from '../components/TitlePage';
import useTranslations from '../components/useTranslations';
import Button from '../components/Button'
// import LogoContainer from '../components/LogoContainer';
import { Check } from 'styled-icons/boxicons-regular/Check';
import Carousel from '../components/Carousel';
import Team from '../components/Team';
import logoText from '../images/essentia_elem_tekst.svg';
import logoIcon from '../images/essentia_elem_icon.svg';

import * as S from '../components/ListWrapper/styled';





const Index = ({ data: { allMarkdownRemark } }) => {
  // useTranslations is aware of the global context (and therefore also "locale")
  // so it'll automatically give back the right translations
  const {
    hello,
    invest,
    implement,
    optimise,
    subline,
    description,
    whyUs,
    independentExpertise,
    extensiveNetwork,
    yearsOfExperience,
    customSolutions,
    organizationalKnowledge,
    more,
    team
  } = useTranslations();

  const postList = allMarkdownRemark.edges;

  const linkRef = React.createRef();

  const onClick = () => {
    linkRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });    
  };
  

  return (
  <>
    <section className="homepage homepage-1">
      <div className="taglineBlock">
        <div className="logo-container">
          <div className="text-container">
            <img src={logoText} alt="Essentia consultancy" className="logo__text"/>
          </div>
          <img src={logoIcon} alt="logo" className="logo__icon"/>
        </div>


        
        <SEO title="Home" />
        <div className="container__title">
          <TitlePage text={hello} />
        </div>
        <div className="container__subtitle">
        <div className="grid-container">
          <span className="subtitle">{invest}</span>
          <span className="subtitle">{implement}</span>
          <span className="subtitle">{optimise}</span>
          </div>
        </div>
        
        <Button type="button"                
                onClick= {onClick}
                buttonStyle="btn--primary--solid"
                buttonSize="btn--large">{more}</Button>
      </div>
    </section>

    <section className="homepage homepage-2">
      <TitlePage ref={linkRef} text={subline} />
      <p>{description}</p>

    </section>

    <section className="homepage homepage-3">
      <S.ListWrapper>
        {postList.map(
          ({
            node: {
              frontmatter: {
                background,
                category,
                date,
                description,
                title,
                subtitle1,
                subtitle2,
                subtitle3,
                image,
              },
              timeToRead,
              fields: { slug },
            },
          }) => (
              <PostItem
                slug={`/${slug}`}
                background={background}
                category={category}
                date={date}
                timeToRead={timeToRead}
                title={title}
                subtitle1={subtitle1}
                subtitle2={subtitle2}
                subtitle3={subtitle3}
                description={description}
                image={image}
                key={title}
              />
            ),
        )}
      </S.ListWrapper>
    </section>

    <section className="homepage homepage-4">
    <div className="titel">
      <TitlePage text={whyUs} />
    </div>
    <div className="usp">
      <div className="usp-item">
      <Check size="50" fill="var(--dark)" />
        
        <div className="usp-copy">
          <h2>{independentExpertise.tagline}</h2>
          <p>{independentExpertise.copy}</p>
        </div>
      </div>

      <div className="usp-item">
      <Check size="50" fill="var(--dark)" />
        
        <div className="usp-copy">
          <h2>{extensiveNetwork.tagline}</h2>
          <p>{extensiveNetwork.copy}</p>
        </div>
      </div>

      <div className="usp-item">
      <Check size="50" fill="var(--dark)" />
        
        <div className="usp-copy">
          <h2>{yearsOfExperience.tagline}</h2>
          <p>{yearsOfExperience.copy}</p>
        </div>
      </div>

      <div className="usp-item">
      <Check size="50" fill="var(--dark)" />
        
        <div className="usp-copy">
          <h2>{customSolutions.tagline}</h2>
          <p>{customSolutions.copy}</p>
        </div>
      </div>

      <div className="usp-item">
      <Check size="50" fill="var(--dark)" />
        
        <div className="usp-copy">
          <h2>{organizationalKnowledge.tagline}</h2>
          <p>{organizationalKnowledge.copy}</p>
        </div>
      </div> 
    </div>
      <span className="frame top left"></span>
      <span className="frame top right"></span>
      <span className="frame bottom left"></span>
      <span className="frame bottom right"></span>
    </section>

    <section className="homepage homepage-5">
      <TitlePage text={team.title} />
      <Team />
      
    </section>
    <Carousel />
  </>
  );
};

export default Index;

export const query = graphql`
  query Index($locale: String!, $dateFormat: String!, ) {
    allMarkdownRemark(
      filter: {
        fields: { locale: { eq: $locale } }
        fileAbsolutePath: {regex: "/(pages)\/.*\\.md$/"}
      }
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 3
    ) {
      edges {
        node {
          frontmatter {
            title
            subtitle1
            subtitle2
            subtitle3
            description
            category
            background
            image
            date(formatString: $dateFormat)

          }
          timeToRead
          fields {
            locale
            slug
          }
        }
      }
    }
  }
`;
// <hr style={{ margin: `2rem 0` }} />   horisontal line

{/* <Check size="50" fill="var(--dark)" />
<Check size="50" fill="var(--dark)" />
<Check size="50" fill="var(--dark)" />
<Check size="50" fill="var(--dark)" />
<Check size="50" fill="var(--dark)" /> */}


